import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import type { HexColor } from '@sorare/core/src/style/types';

export const VAULT_PROGRESS_BAR_COLORS: Record<Rarity, HexColor> = {
  [Rarity.common]: 'var(--c-vault-limited-progressbar)',
  [Rarity.limited]: 'var(--c-vault-limited-progressbar)',
  [Rarity.rare]: 'var(--c-vault-rare-progressbar)',
  [Rarity.super_rare]: 'var(--c-vault-superRare-progressbar)',
  [Rarity.unique]: 'var(--c-vault-unique-progressbar)',
  [Rarity.custom_series]: 'var(--c-vault-limited-progressbar)',
};
